import React, { useContext } from 'react';
import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import useLocalStorage from '../hooks/useLocalStorage';

const ContactsContext = React.createContext();

export function useContacts() {
  return useContext(ContactsContext);
}

export function ContactsProvider({ children }) {
  const {
    auth: { user },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  const [contacts, setContacts] = useLocalStorage(
    `contacts-${user._id}`,
    user.messageRequest.filter((request) => request.status === true)
  );

  console.log(localStorage.getItem(`gamers-world-contacts-${user._id}`));
  function createContact(id, name) {
    setContacts((prevContacts) => {
      return [...prevContacts, { id, name }];
    });
  }

  return (
    <ContactsContext.Provider value={{ contacts, createContact }}>
      {children}
    </ContactsContext.Provider>
  );
}
